import { Injectable } from '@angular/core';
import { AgCellLocalStoreService, AgCellState } from '../../../../global/gx-ag-grid/ag-cell-local-store.service';
import { Observable, switchMap } from 'rxjs';
import { selectIsLocationFieldBlacklisted } from '../../state/location-list-selectors';
import { LSCField } from '../../../../../models/LSCFields';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { LinkCellSubtype } from './link-cell.component';
import { LocationListLocalStoreService } from '../../location-list-local-store.service';

interface LinkCellState extends AgCellState {}

@Injectable()
export class LinkCellLocalStoreService extends AgCellLocalStoreService<LinkCellState>{

  readonly viewModel$: Observable<{
    fieldName: LSCField,
    value: string | string[],
    loading: boolean,
    isFieldBlacklisted: boolean,
    subtype: LinkCellSubtype }> = this.select({
      fieldName: this.params$.pipe(map((params) => {
            return <LSCField>params?.colDef?.field;
          })),
      value: this.cellValue$,
      loading: this.params$.pipe(
          switchMap((params) => this.locationGridStore.loadingValues$.pipe(
              map(loadingValues => loadingValues[params?.data?.id]?.[params?.colDef?.field])
          ))),
      isFieldBlacklisted: this.params$.pipe(
          switchMap((params) =>
              this.store.select(selectIsLocationFieldBlacklisted(
                  params?.data?.id,
                  (params?.colDef?.field) as LSCField)
              )
          )),
      subtype: this.params$.pipe(map((params) => {
        switch (params?.colDef?.field) {
          case LSCField.website:
          case LSCField.menuURL:
            return LinkCellSubtype.SINGLE_LINK;
          case LSCField.socialMediaUrls:
          case LSCField.reservationsURL:
          case LSCField.orderAheadURL:
          case LSCField.appointmentURL:
            return LinkCellSubtype.MULTIPLE_LINKS;
          default: return undefined;
        }
      })),
  })

  constructor(private store: Store, private locationGridStore: LocationListLocalStoreService) {
    super({
      cellValue: null,
      params: null,
    })
  }

}
